// Zgłoszenia do wsparcia: formularz dla zalogowanych, formularz publiczny (ze strony logowania)
// i strona weryfikacji zgłoszenia z linku w e-mailu. Mockup nie ma tych ekranów, więc cały
// plik to tłumaczenie własne. Treść błędu zwrócona przez backend wyświetlamy bez zmian.
//
// VERIFY: cały plik.
export default {
  // Pola wspólne dla obu formularzy.
  form: {
    name: 'Imię i nazwisko',
    namePlaceholder: 'Podaj imię i nazwisko',
    nameRequired: 'Podaj imię i nazwisko',
    emailPlaceholder: 'Podaj adres e-mail',
    subject: 'Temat',
    subjectPlaceholder: 'Podaj temat zgłoszenia',
    subjectRequired: 'Podaj temat',
    message: 'Wiadomość',
    messagePlaceholder: 'Opisz problem lub pytanie',
    messageRequired: 'Wpisz wiadomość',
    category: 'Kategoria',
    categoryPlaceholder: 'Wybierz kategorię (opcjonalnie)',
    // Wartości opcji (`common`, `remove_account`, `remove_data`) to kontrakt z API.
    categories: {
      common: 'Ogólne',
      removeAccount: 'Usunięcie konta',
      removeData: 'Usunięcie danych',
    },
    attachment: 'Załącznik',
    uploadImage: 'Prześlij obraz',
    submit: 'Wyślij zgłoszenie',
    success: 'Zgłoszenie {{ticketNumber}} zostało wysłane. Odpowiemy najszybciej, jak to możliwe.',
    // Fallback, gdy backend nie odesłał treści błędu.
    submitFailed: 'Nie udało się wysłać zgłoszenia',
  },
  // Dane zalogowanego użytkownika nad formularzem.
  userInfo: {
    name: 'Imię i nazwisko:',
    email: 'Adres e-mail:',
  },
  publicPage: {
    backToSignIn: 'Wróć do logowania',
    title: 'Kontakt z pomocą techniczną',
    subtitle: 'Coś nie działa? Wypełnij formularz, a odpowiemy najszybciej, jak to możliwe.',
  },
  verify: {
    verifying: 'Weryfikowanie zgłoszenia…',
    verified: {
      title: 'Tożsamość zweryfikowana',
      message: 'Zgłoszenie zostało przyjęte i jest w trakcie realizacji.',
    },
    expired: {
      title: 'Link wygasł',
      message: 'Ten link weryfikacyjny wygasł (jest ważny przez 24 godziny).',
      hint: 'Skontaktuj się z pomocą techniczną.',
    },
    invalid: {
      title: 'Nieprawidłowy link',
      message: 'Ten link weryfikacyjny jest nieprawidłowy lub został już wykorzystany.',
    },
    failed: {
      title: 'Weryfikacja nie powiodła się',
      message: 'Wystąpił błąd podczas weryfikacji zgłoszenia.',
    },
  },
} as const;
